import { Formik } from 'formik';
import { Link } from 'react-router-dom';

import { signUpSchema } from '../schemas/sign-up.schema';
import AuthContainer from './AuthContainer';
import AuthForm from './AuthForm';
import AuthInput from './AuthInput';
import AuthOr from './AuthOr';
import AuthSub from './AuthSub';
import AuthSubmit from './AuthSubmit';
import AuthTitle from './AuthTitle';

type PropTypes = {
	handleSubmit: (username: string, password: string) => Promise<void>;
	signUpTitle: string;
	loading: boolean;
};

export default function SignUpForm({
	handleSubmit,
	loading,
	signUpTitle,
}: PropTypes) {
	const initialValues = {
		username: '',
		password: '',
	};

	return (
		<AuthContainer>
			<Formik
				initialValues={initialValues}
				validationSchema={signUpSchema}
				onSubmit={({ username, password }) => handleSubmit(username, password)}
			>
				{({ errors, touched }) => (
					<AuthForm>
						<AuthTitle>{signUpTitle}</AuthTitle>
						<AuthInput
							name="username"
							label="Username"
							type="email"
							placeholder="user@example.com"
							error={!!errors.username}
							touched={touched.username}
							data-testid="sign-up-username"
						/>
						<AuthInput
							name="password"
							label="Password"
							type="password"
							placeholder="********"
							error={!!errors.password}
							touched={touched.password}
							data-testid="sign-up-password"
						/>
						<AuthSubmit loading={loading} data-testid="sign-up-submit" />
					</AuthForm>
				)}
			</Formik>
			<AuthOr />
			<AuthSub>
				<p>
					Already have an account?{' '}
					<Link
						className="font-medium text-blue-500"
						to="/auth/sign-in"
						data-testid="link-sign-in"
					>
						Sign in
					</Link>
				</p>
			</AuthSub>
		</AuthContainer>
	);
}
